import Grid from '@mui/material/Grid2';
import './footer.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="footer-container">
      <div className="footer-content-container main-content-container">
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <h4 className="footer-header">{t('footer.contact')}</h4>
            <p className="footer-para">{t('footer.contactDescription')}</p>
            <Link to="/contact">
              <button className='contact-us-btn'>
                {t('footer.contactButton')}
              </button>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <h4 className="footer-header">{t('footer.address')}</h4>
            <p className="footer-para">FMP8+9JM, Talang Duku, Taman Rajo, Muaro Jambi Regency</p>
            <p className="footer-para">Jambi 36382, Indonesia</p>
          </Grid>
        </Grid>
      </div>
      <div className="footer-credit-row flex-center">
        <div className="footer-copyright content-padding">
          {t('footer.copyright')}
        </div>
      </div>
    </div>
  );
};

export default Footer;
